import strings from 'mobile_web/strings'

export const getScannerLabel = ({
	keypadEnabled,
	qrEnabled,
	searchEnabled,
}: {
	keypadEnabled: boolean
	qrEnabled: boolean
	searchEnabled: boolean
}): string => {
	if (keypadEnabled && !qrEnabled && !searchEnabled) return strings.keypad_entry_tab_label
	if (!keypadEnabled && !qrEnabled && searchEnabled) return strings.search_tab_label

	return strings.scan_and_find
}
